export default [
  // B端仪表板
  {
    path: '/player',
    name: 'LayoutDashboard',
    component: () => import('@/upgrade-page/views/dashboard/layout'),
    children: [
      // 仪表板首页
      {
        path: '/player/dashboard',
        name: 'PlayerDashboard',
        component: () => import('@/upgrade-page/views/dashboard/index'),
      },
      // 陪玩订单
      {
        path: '/player/orders',
        name: 'PlayerOrder',
        component: () => import('@/upgrade-page/views/dashboard/orders'),
      },
      // 收入
      {
        path: '/player/income',
        name: 'PlayerIncome',
        component: () => import('@/upgrade-page/views/dashboard/income'),
      },
      // 技能管理
      {
        path: '/player/skills',
        name: 'PlayerSkills',
        component: () => import('@/upgrade-page/views/dashboard/skills'),
      },
      // 技能管理-卡片詳情
      {
        path: '/player/skill/detail',
        name: 'PlayerSkillDetail',
        component: () => import('@/upgrade-page/views/dashboard/skills/skill-detail'),
        meta: {
          pageWidth: 980,
        }
      },
      // 自推廣設定
      {
        path: '/player/recommend',
        name: 'PlayerRecommend',
        component: () => import('@/upgrade-page/views/dashboard/recommend'),
      },
      // 邀约用户邀请新人
      {
        path: '/player/invite-record',
        name: 'InviteRecord',
        component: () => import('@/upgrade-page/views/invite/invite-record.vue'),
      },
    ]
  },
]
